define('glu/grid/filter/badges/filterBadgeHeader',['require','../../../itemView','hbs!./filterBadgeHeader.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../../itemView'),
        tmpl = require('hbs!./filterBadgeHeader.hbs');

    return ItemView.extend({
        template: tmpl,
        tagName: 'span',

        className: 'label label-filter',

        events: {
            'click .remove-filter': 'handleRemove',
            'click': 'reopenFilter'
        },

        modelEvents: {
            'change': 'render'
        },

        handleRemove: function(e) {
            e.preventDefault();
            e.stopPropagation();

            this.options.masterCollection.trigger('grid:clear:filter:' + this.model.get('field'), this);

            return this.model.destroy();
        },

        reopenFilter: function() {
            this.options.filters.trigger('grid:reopen:filter', this.model);
        }
    });
});

